<template>
  <div v-if="canAccessPage">
    <dashboard-fornecedor-filtro
      v-model="abrirFiltro"
      @DashboardFornecedorFiltro__AplicaFiltros="aplicarFiltros">
    </dashboard-fornecedor-filtro>

    <v-container fluid grid-list-md pa-0>
      <v-row align="center" justify="end" class="font-weight-black" style="min-height: 50px">
        <v-col cols="12" class="text-right" xs1>
          <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <liquidacao-cards-totalizadores
            ref="cards_totalizadores"
            :filtros="filtros"
            percentual="quantidade">
          </liquidacao-cards-totalizadores>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="8" class="pt-0">
          <v-row>
            <v-col cols="12" class="px-3">
              <v-card style="width: 100%;">
                <dashboard-varejo-grafico :filtros="filtros"/>
              </v-card>
            </v-col>
            <v-col cols="12" >
              <dashboard-fornecedor-nota-debito :filtros="filtros">
              </dashboard-fornecedor-nota-debito>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pt-0">
          <v-row>
            <v-col cols="12" d-flex >
              <dashboard-pendencias-planejamento
                :filtros="filtros"
                :dashFornecedor="true" />
            </v-col>
            <v-col cols="12" d-flex >
              <dashboard-pendencias-apuracao
                :filtros="filtros"
                :dashFornecedor="true" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import LiquidacaoCardsTotalizadores from '../../../liquidacao-acao/LiquidacaoCardsTotalizadores';

import DashboardVarejoGrafico from '../DashVarejoGrafico';
import DashboardPendenciasApuracao from '../../DashboardPendenciasApuracao';
import DashboardPendenciasPlanejamento from '../../DashboardPendenciasPlanejamento';

import DashboardFornecedorFiltro from './DashFornecedorFiltro';
import DashboardFornecedorNotaDebito from './DashFornecedorNotaDebito';

export default {
  name: 'DashboardFornecedor',
  data() {
    return {
      filtros: null,
      abrirFiltro: false,
    };
  },
  components: {
    LiquidacaoCardsTotalizadores,
    DashboardVarejoGrafico,
    DashboardFornecedorFiltro,
    DashboardPendenciasApuracao,
    DashboardPendenciasPlanejamento,
    DashboardFornecedorNotaDebito,
  },
  computed: {
    ...generateComputed('ACESSO_FORNECEDOR', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el.startsWith('ACESSO_FORNECEDOR')).length;
    },
  },
  methods: {
    aplicarFiltros(filtrosAplicados) {
      if (!filtrosAplicados || !this.filtroPeriodoValido(filtrosAplicados)) {
        return;
      }
      if (!filtrosAplicados.data_inicio && !filtrosAplicados.data_fim) {
        filtrosAplicados.data_inicio = moment(new Date(new Date().getFullYear(), 0, 1), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
        filtrosAplicados.data_fim = moment(new Date(new Date().getFullYear(), 11, 31), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
      }
      this.filtros = {
        ...filtrosAplicados,
      };
    },
    filtroPeriodoValido(filtrosAplicados) {
      if (filtrosAplicados.data_inicio || filtrosAplicados.data_fim) {
        let dtInicio = '';
        let dtFinal = '';
        dtInicio = this.moment(filtrosAplicados.data_inicio, 'YYYY-MM-DD');
        dtFinal = this.moment(filtrosAplicados.data_fim, 'YYYY-MM-DD');
        if (dtFinal.isBefore(dtInicio)) {
          this.$toast(this.$t('message.data_final_antes_inicial'));
          return false;
        }
        if ((filtrosAplicados.data_inicio && !filtrosAplicados.data_fim)
          || (!filtrosAplicados.data_inicio && filtrosAplicados.data_fim)) {
          this.$toast(this.$t('message.data_final_e_inicial'));
          return false;
        }
        return true;
      }
      return true;
    },
  },
};
</script>
